import styled from "styled-components"
import { Col, Row, Text, VerticalSeparator, VImage } from "../../style/base.style"
import { logo_svg } from "../../constants/images"
import { Colors } from "../../style/colors"
import { menuItems } from "./nav";
import { Link, Links, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDictionary } from "../../contexts/dictionary";
import { useContactType } from "../../contexts/ContactContext";
import { ActionButton, ButtonStyle } from "../buttons/ActionButton";
import { ProfileImg } from "../common/profileImage";
import { useFormHandling } from "../../hooks/formUtils";
import { RequestConfigs } from "../../api";
import { dashboardMenuItems } from "../dashboardSidebar";

interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

export const MobileMenu = ({isOpen, onClose}: MobileMenuProps) => {
    return (
        <MainContainer className={`main-menu-mob ${isOpen ? 'open' : ''}`}>
            <Row $justifyContent="space-around" $padding="20px" $width="100%">
            
                <Col $width="80%" $justifyContent="flex-start" $alignItems="flex-start">
                    <Link to="/" onClick={onClose}>
                    <VImage src={logo_svg} className="img-fluid" alt="Logo" $width="150px" />
                    </Link>   
                </Col> 
                <Col $width="30px" $justifyContent="flex-end">
                    <CloseButton onClick={onClose}>✕</CloseButton>
                </Col>
            </Row>
            
            <VerticalSeparator />
            <Row $justifyContent="center" $alignItems="space-between" $padding="20px" $width="100%" $height="100%">
                <MenuNavigation closeMenu={onClose}/>
                <MemberArea/>
            </Row>
        </MainContainer>
    );
}


const Menu = ({ menu,closeMenu }:{menu:MenuItem,closeMenu:()=>void})=>{
    const {translate} = useDictionary();
    const location = useLocation();
    const active = location.pathname.includes(menu.to)
    console.log(location.pathname,menu.to,active)
    return (
        <Col  $width="100%" $justifyContent="flex-start" $alignItems="flex-start" $padding="10px" >
            <Link to={menu.to} onClick={closeMenu} ><Text $margin="0" $color={active?Colors.primary:Colors.blackText}>{translate(menu.label)}</Text></Link>
            
        </Col>
    )
}

const SubMenu = ({ item,closeMenu }:{item:MenuItem,closeMenu:()=>void})=>{
    const [isCollapsed,setIsCollapsed] = useState<boolean>(false);
    const {translate} = useDictionary();
    return (
        <Row >
    <Row  $width="100%" $justifyContent="space-between" $alignItems="center" $padding="10px" onClick={()=>setIsCollapsed(prev=>!prev)}>
        <Col>
            <Text $margin="0" >{translate(item.label)}</Text>
        </Col>
        <Col>
            <Text $fontWeight={700} $color={Colors.primary} $margin="0">{isCollapsed? "⏶":"⏷" }</Text>
           
        </Col>
       
        
    </Row>
    <Row $border={isCollapsed?`1px solid ${Colors.primary} `:"none"} $borderRadius={5} $width="100%" >
 
        {
                isCollapsed && item.items?.map((subItem, index) => {
                    return (
                        <Menu menu={subItem} key={index} closeMenu={closeMenu}/>
                    )
                })
            }
        
    </Row>
    </Row>
    )
}

interface MenuNavigationProps {
    closeMenu: () => void;
}

const MenuNavigation = ({closeMenu}:MenuNavigationProps)=>{

    const accountMenu:MenuItem = {
        type: "subMenu",
        label: 'personal_area',
        to: "#",
        items: dashboardMenuItems
      }
      const {contact} = useContactType()

    return (
        <Col $width="100%" $justifyContent="flex-start" $alignItems="flex-start">
            {
                contact && 
                <SubMenu item={accountMenu} key={50} closeMenu={closeMenu} />
            
            }
            {menuItems.map((item, index) => {
                if(item.type === "subMenu"){
                    return (
                        <SubMenu item={item} key={index} closeMenu={closeMenu} />
                    )
                } else {
                    return (
                        <Menu menu={item} key={index} closeMenu={closeMenu}/>  
                    )
                }
            })}
        </Col>
    )
}

const MemberArea = () => {
    const {contact} = useContactType()
    const {translate} = useDictionary()
    const navigate = useNavigate();
    const {handleClick,serverRes} = useFormHandling({ requestType: RequestConfigs.logout })
      const handleLogout = () => {
        console.log("logout clicked1");
        handleClick()
      }
    
      useEffect(() => {
        if (serverRes) {
          if (serverRes.succeeded) {
            navigate("/login")
          }
        }
      }, [serverRes]);


    return (
        <MemberAreaContainer>
           
                {
                    !contact && 
                    <Row $gap={10}>
                    <ActionButton style={ButtonStyle.dark} width="45%" label={translate('register')} onClick={()=>navigate('/register')}/>
                    <ActionButton style={ButtonStyle.light} width="45%" label={translate('login')} onClick={()=>navigate('/login')}/>
                    </Row>
                }

{
                    contact && 
                    <Row $gap={10} $justifyContent="center" $alignItems="center">
                        <Row $width="70%" $gap={10} $justifyContent="flex-start" $alignItems="center">
                            <ProfileImg width={40} height={40} borderRadius="10px"/>
                            <Text $fontSize="14px" $margin="0">{contact.Email}</Text>
                        </Row>
                    
                        <ActionButton style={ButtonStyle.dark} width="25%" label={translate('logout')} onClick={handleLogout}/>

                    
                    </Row>
                }

         
        </MemberAreaContainer>
    )
}

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    background-color: ${Colors.whiteBackground};
    width: 100%;
    height: 100%;
    z-index: 999;
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%);
    overflow-y: auto;
    /* padding-bottom: 60px; */
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);

    &.open {
        transform: translateX(0);
    }
`

const CloseButton = styled.button`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #465D7C;
    border: none;
    color: #FFF;
    box-shadow: none;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
`

const MemberAreaContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 20px;
    color: #FFF;
    font-size: 14px;
`